import { render, staticRenderFns } from "./uploaddownexceltarget.vue?vue&type=template&id=9f27520c"
import script from "./uploaddownexceltarget.vue?vue&type=script&lang=js"
export * from "./uploaddownexceltarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports